import React from 'react';
import PropTypes from 'prop-types';

import {Paper, Typography, Stack} from 'views/components';
import {AccessTime as AccessTimeIcon, CalendarToday as CalendarTodayIcon, FreeBreakfastOutlined as FreeBreakfastOutlinedIcon} from 'views/icons';
import {Translate} from 'views/module';

import {formatEventDate, formatEventTime, getEventMoment} from '../dateTime';

const TimeTile = (props) => {
  const {event} = props;

  const timezone = event.eventData.timezone;
  const startDateTime = getEventMoment(event.eventData.startTime, timezone);
  const endDateTime = getEventMoment(event.eventData.endTime, timezone);

  const formattedDate = formatEventDate(event.eventData.startTime, timezone);
  const startTime = formatEventTime(event.eventData.startTime, timezone);
  const endTime = formatEventTime(event.eventData.endTime, timezone);
  const duration = endDateTime.diff(startDateTime, 'hours');

  const hasBreaks = event.breaks;

  return (
    <Paper sx={{p: 2, mb: 2, borderRadius: 4}}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{mb: 2}}>
        <AccessTimeIcon sx={{width: 24, height: 24, color: '#b0b0b0'}}/>
        <Typography variant="h6">
          <Translate expression='schedule.eventDetail.TimeSection.Title' />
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <CalendarTodayIcon fontSize="small" />
        <Typography>
          {formattedDate}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1} mt={1}>
        <AccessTimeIcon fontSize="small" />
        <Typography>
          {startTime} - {endTime}
        </Typography>
        <Typography color="text.secondary" ml={2}>
          {duration} <Translate expression={duration === 1 ? 'schedule.eventDetail.TimeSection.hour' : 'schedule.eventDetail.TimeSection.hours'} />
        </Typography>
      </Stack>
      {
        hasBreaks && (
          <Stack direction="row" alignItems="center" spacing={1} mt={1}>
            <FreeBreakfastOutlinedIcon fontSize="small" />
            <Typography>
              <Translate
                expression='schedule.eventDetail.TimeSection.BreakDetails'
                substitute={{
                  breakCount: event.breaks.breakCount,
                  breakDuration: event.breaks.breakDuration,
                }}
              />
            </Typography>
            <Typography color="text.secondary" ml={2}>
              <Translate
                expression="schedule.eventDetail.TimeSection.TotalBreakTime"
                substitute={{totalBreakTime: event.breaks.breakCount * event.breaks.breakDuration}}
              />
            </Typography>
          </Stack>
        )
      }
    </Paper>
  );
};

TimeTile.propTypes = {
  event: PropTypes.object.isRequired,
};

export default TimeTile;
